import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/auth/services/auth.service';
import { environment } from 'src/environments/environment';

export interface HourTimeType {
  time: string;
}

export interface ScheduleType {
  arm1: HourTimeType;
  arm2: HourTimeType;
  disarm1: HourTimeType;
  disarm2: HourTimeType;
  days: number[];
}

export interface ScheduleControlCreateRequest {
  notifyMonitoringCenter: boolean;
  partitionId: string;
  schedules: ScheduleType[];
}

@Injectable({
  providedIn: 'root',
})
export class ScheduleControlService {
  uriReminders = `${environment.webappEndpoint}/partition`;
  constructor(private readonly http: HttpClient, private readonly auth: AuthService) {}

  upsertReminders = (props: ScheduleControlCreateRequest) =>
    this.http.post(
      `${this.uriReminders}/${props.partitionId}/reminders`,
      {
        reminders: {
          schedules: props.schedules,
          notifyMonitoringCenter: props.notifyMonitoringCenter,
        },
        selectedLanguage: this.auth.user.language,
      },
      {
        headers: { Authorization: `Bearer ${this.auth.getToken()}` },
      }
    );
}
